import { create } from "zustand";

const useStore = create((set, get) => ({
  nomeCompleto: "",
  emailPrincipal: "",
  cpf: "",
  rendaMensalClient: "",
  rendaMensalProponent4: "",
  idadeCliente: "",
  numero: "",
  prazoMeses: 0,
  nomeCompletoProponente4: "",
  nascimentoProponente4: "",
  selectedValue: "",
  situacaoImovel: "",
  loading: false,
  managerErro: false,
  nomeCompletoIsErro: false,
  emailPrincipalIsErro: false,
  nascimentoIsErro: false,
  cpfIsErro: false,
  rendaMensalIsErro: false,
  numeroIsErro: false,
  
  isLoadingDowloadSimulation: false,
  setIsLoadingDowloadSimulation: (value) => set({ isLoadingDowloadSimulation: value}),

  setNomeCompletoIsErro: (value) => set({ nomeCompletoIsErro: value }),
  setEmailPrincipalIsErro: (value) => set({ emailPrincipalIsErro: value }),
  setNascimentoIsErro: (value) => set({ nascimentoIsErro: value }),
  setCpfIsErro: (value) => set({ cpfIsErro: value }),
  setRendaMensalIsErro: (value) => set({ rendaMensalIsErro: value }),
  setNumeroIsErro: (value) => set({ numeroIsErro: value }),
  setManagerError: (value) => set({ managerErro: value }),
  setLoading: (isLoading) => set({ loading: isLoading }),
  setNomeCompleto: (value) => set({ nomeCompleto: value || "" }),
  setCpf: (value) => set({ cpf: value || "" }),
  setEmailPrincipal: (value) => set({ emailPrincipal: value || "" }),
  setIdadeCliente: (value) => set({ idadeCliente: value || "" }),
  setNumero: (value) => set({ numero: value || "" }),
  setPrazoMeses: (value) => set({ prazoMeses: parseFloat(value) || 0 }),
  setSelectedValue: (value) => set({ selectedValue: value }),
  setSituacaoImovel: (value) => set({ situacaoImovel: value }),
  setValorFinanciamento: (value) =>
    set({ valorFinanciamento: parseFloat(value) || 0 }),
  setValorEntrada: (value) => set({ valorEntrada: parseFloat(value) || 0 }),
  setValorFGTS: (value) => set({ valorFGTS: parseFloat(value) || 0 }),
  setPrazo: (value) => set({ prazo: parseFloat(value) || 0 }),
  setNomeCompletoProponente4: (value) =>
    set({ nomeCompletoProponente4: value || "" }),
  setNascimentoProponente4: (value) =>
    set({ nascimentoProponente4: value || "" }),
  setRendaMensalClient: (value) =>
    set({ rendaMensalClient: parseFloat(value) || 0 }),
  setRendaMensalProponent4: (value) =>
    set({ rendaMensalProponent4: value || "" }),

  simulacoes: [],
  linkSimulacao: "",
  setLinkSimulacao: (value) => set({ linkSimulacao: value || "" }),

  id : "", 
  setAdd: (value) => 
    set({ id: value }), 

  adicionarSimulacao: (novaSimulacao) => {
    set((state) => ({
      simulacoes: [novaSimulacao, ...state.simulacoes],
    }));
  },
  resetSimulacoes: () => set({ simulacoes: [], id: "" }),

}));

export default useStore;
